import { FamilySituation, WorkSituation } from "./interfaces";

import { isDefined } from "Utils/functions";

export const incomeDependencyOrDebtResponsibleFormElementsActive = (
  familySituation: FamilySituation,
  incomeOrDebt: number | undefined,
): boolean => {
  return (
    familySituation &&
    (familySituation === FamilySituation.MARRIED ||
      familySituation === FamilySituation.COHABITANT) &&
    isDefined(incomeOrDebt) &&
    incomeOrDebt > 0
  );
};

export const workSituationFormElementsActive = (
  workSituation: WorkSituation,
): boolean => {
  return (
    workSituation &&
    (workSituation === WorkSituation.WORK_PRIVATE ||
      workSituation === WorkSituation.WORK_PUBLIC ||
      workSituation === WorkSituation.SELF_EMPLOYED)
  );
};

export const disabilityPensionFormElementsActive = (
  workSituation: WorkSituation,
): boolean => {
  return (
    workSituation &&
    (workSituation === WorkSituation.WORK_PRIVATE ||
      workSituation === WorkSituation.SELF_EMPLOYED)
  );
};
